import { render, staticRenderFns } from "./NewsPage.vue?vue&type=template&id=351ba4b7&"
import script from "./NewsPage.vue?vue&type=script&lang=js&"
export * from "./NewsPage.vue?vue&type=script&lang=js&"
import style0 from "./NewsPage.vue?vue&type=style&index=0&id=351ba4b7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports